import { ApiRequestConfig, CancelToken } from 'api';
import { get, post } from 'features/api';
import { call, select } from 'redux-saga/effects';
import log from 'loglevel';
import { getRegionCode } from 'common/selectors';
import { FetchModels } from '../types';
import { processFetchedResult } from './process-fetched-result';
import { postReviewResponseTransform } from './post-review-response';
import { takePhotoId } from './response-processor';

export function* fetchReviewsPage(props: FetchModels.ReviewsRequestProps, config: ApiRequestConfig) {
  const regionCode = (yield select(getRegionCode)) as ReturnType<typeof getRegionCode>;
  const data = yield* get<FetchModels.ReviewsResponse>(
    'get-product-reviews',
    { ...props, regionCode },
    config,
  );
  return processFetchedResult(data);
}

export function* postReviewForm(formData: FetchModels.PostReviewData, cancelToken?: CancelToken) {
  const regionCode = (yield select(getRegionCode)) as ReturnType<typeof getRegionCode>;
  const data = (yield* post(
    'send-review',
    {
      review: formData,
    },
    {
      cancelToken,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
    },
    {
      regionCode,
    },
  )) as unknown;

  return postReviewResponseTransform(data as FetchModels.PostReviewResponseWithError);
}

export function* postPhoto(file: File, cancelToken?: CancelToken, regionCode?: string) {
  const requestPayload = new FormData();
  requestPayload.append('photo', file);
  const data = yield* post(
    'send-review-photos',
    requestPayload,
    {
      cancelToken,
    },
    {
      regionCode,
    },
  );

  return takePhotoId(data as FetchModels.UploadPhotoFetchResponse);
}

export function* postReviewsOpinion(reviewId: string, voterId: string, opinion: string, productId: string) {
  try {
    const regionCode = (yield select(getRegionCode)) as ReturnType<typeof getRegionCode>;
    yield call(
      post,
      'post-review-opinion',
      {
        vote: {
          productId,
          reviewId,
          voterId,
          opinion,
        },
      },
      {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
        },
      },
      {
        regionCode,
      },
    );
  } catch (err) {
    log.warn('postReviewsOpinion request is failed: ', err);
  }
}

export function* cancelReviewsOpinion(
  reviewId: string,
  voterId: string,
  opinion: string,
  productId: string,
) {
  try {
    const regionCode = (yield select(getRegionCode)) as ReturnType<typeof getRegionCode>;
    yield call(
      post,
      'post-review-opinion',
      {
        vote: {
          productId,
          reviewId,
          voterId,
          opinion,
          cancel: true,
        },
      },
      {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
        },
      },
      {
        regionCode,
      },
    );
  } catch (err) {
    log.warn('cancelReviewsOpinion request is failed: ', err);
  }
}
